<!--
 * @Description: 
 * @Date: 2022-02-25 16:31:58
-->
<template>
  <el-dialog
    title="活动参与人员"
    :visible="true"
    width="95%"
    top="2vh"
    :before-close="() => $emit('remove')"
  >
    <table-render
      ref="tableRender"
      :config="config"
      height="60vh"
      :prop-data="{
        query: {
          serviceActivityId: serviceActivityId
        }
      }"
      :rowClassName="
        ({ row, rowIndex }) =>
          getUnqualifiedRowConfig({
            row: row,
            rowIndex: rowIndex,
            isNotUnqualified: isNotUnqualified(row)
          })
      "
      pageLayout="total, sizes, prev, pager, next, jumper"
    />
  </el-dialog>
</template>
<script>
import tableRender from '@/components/tableRender';
import config from './config/index.js';
import { getUnqualifiedRowConfig } from '@/methods/unqualified';

export default {
  name: 'activePersonList',
  props: ['serviceActivityId'],
  provide() {
    return {
      indexPage: this, // 把当前实例传递给后续弹层使用
      _parent: this
    };
  },
  components: { tableRender },
  data: () => ({
    getUnqualifiedRowConfig,
    config: config
  }),
  // render(_h) {
  //   let _vm = this;
  //   return _h('div', [
  //     _h('table-render', {
  //       ref: 'tableRender',
  //       attrs: { config: _vm.config }
  //     })
  //   ]);
  // },
  methods: {
    isNotUnqualified(row) {
      return !(
        ('superviseStatus' in row && row.superviseStatus === 3) ||
        row.zbBlackStatus === 2
      );
    }
  },
  mounted() {
    // pagination.pageSizes = [15, 60, 100];
    // pagination.layout = 'total, sizes, prev, pager, next, jumper';
    // console.log(this.$options.render);
  }
};
</script>

<style scoped></style>
